import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpBackend) // https://github.com/i18next/i18next-http-backend
  .use(LanguageDetector) // https://github.com/i18next/i18next-browser-languageDetector
  .use(initReactI18next) // https://www.i18next.com/overview/configuration-options
  .init({
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: new URL(import.meta.env.VITE_API_URL).toString() + 'locale/{{lng}}.json',
    },
    react: {
      useSuspense: true, // Ensure Suspense properly waits for i18n initialization
    },
  });

type TLanguageInfo = {
  [key: string]: {
    name: string;
    flag: string;
  };
};

export const LanguageInfo: TLanguageInfo = {
  en: {
    name: 'English',
    flag: '🇬🇧',
  },
  pt: {
    name: 'Português',
    flag: '🇵🇹',
  },
  it: {
    name: 'Italiano',
    flag: '🇮🇹',
  },
  pl: {
    name: 'Polski',
    flag: '🇵🇱',
  },
  fr: {
    name: 'Français',
    flag: '🇫🇷',
  },
  jp: {
    name: '日本語',
    flag: '🇯🇵',
  },
  hi: {
    name: 'हिंदी',
    flag: '🇮🇳',
  },
  zh: {
    name: '中文',
    flag: '🇨🇳',
  },
  ko: {
    name: '한국어',
    flag: '🇰🇷',
  },
  es: {
    name: 'Español',
    flag: '🇪🇸',
  },
  de: {
    name: 'Deutsch',
    flag: '🇩🇪',
  },
  tr: {
    name: 'Türkçe',
    flag: '🇹🇷',
  },
};

export const SupportedLanguages = Object.keys(LanguageInfo);
export type TSupportedLanguages = (typeof SupportedLanguages)[number];

export default i18n;
